import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import Media from '../../../../../../types/media/Media';
import { UploadUseCase } from '../../../../../../types/shared/media/UploadUseCase';
import { UploadMediaComponent } from '../upload-media/upload-media.component';

@Component({
    selector: 'app-replace-file-dialog',
    templateUrl: './replace-file-dialog.component.html',
    styleUrls: [ './replace-file-dialog.component.scss' ],
    imports: [
        Dialog,
        UploadMediaComponent,
        Button
    ]
})
export class ReplaceFileDialogComponent {
    @Input() public visible: boolean = false;
    @Input() public media: Media = new Media({});
    @Output() public visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() mediaReplaced = new EventEmitter<unknown>();

    public selectedFile: File | null = null;
    public readonly UploadUseCase = UploadUseCase;

    public closeDialog(): void {
        this.visible = false;
        this.visibleChange.emit(this.visible);
        this.selectedFile = null;
    }

    public onUploadSuccess() {
        this.closeDialog();
        this.mediaReplaced.emit();
    }
}
